import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HasPermissionPipe } from './has-permission.pipe';
import { FormErrorPipe } from './form-error.pipe';
import { SafeUrlPipe } from './safe-url.pipe';

@NgModule({
  declarations: [FormErrorPipe, SafeUrlPipe, HasPermissionPipe],
  imports: [CommonModule],
  exports: [FormErrorPipe, SafeUrlPipe, HasPermissionPipe],
})
export class PipesModule {}
